// Initialize the application when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.getElementById('overlay');
  
  // Create glass elements with the same properties as the React version
  const glassElements = [
    new GlassElement({
      width: 3000,
      height:78,
      depth:7,
      blur:1,
      chromaticAberration: 1,
      debug: false
    })
  ];

  // Append all glass elements to the overlay
  glassElements.forEach(glassElement => {
    glassElement.appendTo(overlay);
  });

  // Add a note about browser compatibility
  console.log('Note: You need a chromium-based browser to see the effect');
}); 